import { Box, Typography } from "@mui/material";
import styled from "styled-components";
import theme from "../../../styles/theme";

export const ContainerHeader = styled(Box)`
  && {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin: 25px 2vw 30px 60px;
    align-items: center;
    height: 48px;
    max-height: unset;
    justify-content: space-between;

    @media (${theme.devices.tablet}) {
      margin: 25px 20px 30px 60px;
      flex-direction: row;
      flex-wrap: nowrap;
      height: auto;
      /* justify-content: flex-start; */
    }
  }
`;

export const ContainerTitle = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  @media (${theme.devices.tablet}) {
    margin-left: 6vw;
    margin-top: 1vh;
  }
`;
export const ContainerActions = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  @media (${theme.devices.tablet}) {
    margin-left: 6vw;
    margin-top: 1vh;
  }
`;
export const TitleTypography = styled(Typography)`
  && {
    white-space: nowrap;
    font-weight: 600;
    font-size: 20px;
    line-height: 28px;
    color: white;
    @media (${theme.devices.tablet}) {
      font-size: ${theme.fontSize.mm};
    }
  }
`;

export const Divider = styled.div`
  width: 100%;
  height: 0;
  border: 1px solid #404252;
  flex: 1;
  display: block;
`;

export const ContainerIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  & > svg {
    color: ${theme.colors.palete.gold};
    width: 25px;
    height: 25px;
  }
`;
